import React, { useRef } from 'react'
import { Button, ModalFooterAction } from '@apex/component-library'
import {
  Box,
  AlertDialogCloseButton,
  AlertDialog,
  AlertDialogBody,
  Flex,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay
} from '@chakra-ui/react'

export interface TransferPreviewModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitting: boolean
  isSubmitDisabled: boolean
  header: string
  confirmLabel?: string
  children: JSX.Element
}

const TransferPreviewModal = ({
  header,
  confirmLabel,
  onClose,
  isOpen,
  onSubmit,
  isSubmitting,
  isSubmitDisabled,
  children
}: TransferPreviewModalProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null)
  return (
    <AlertDialog
      motionPreset='slideInBottom'
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent w='100%' maxW='600px'>
        <AlertDialogHeader textStyle='h1'>{header}</AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>{children}</AlertDialogBody>
        <ModalFooterAction>
          <Flex>
            <Box ml='auto'>
              <Button variant='white' ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant='primary'
                ml={3}
                onClick={onSubmit}
                isLoading={isSubmitting}
                isDisabled={isSubmitDisabled || isSubmitting}
              >
                {confirmLabel || 'Confirm'}
              </Button>
            </Box>
          </Flex>
        </ModalFooterAction>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default TransferPreviewModal
